import { Controller } from "@hotwired/stimulus"

// Displays member details inside a lightweight modal rendered via Turbo Frames.
// Allows closing via backdrop click, the dedicated close button, or Escape key.
export default class extends Controller {
  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
    document.body.classList.add("modal-open")
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.body.classList.remove("modal-open")
  }

  close(event) {
    if (event) event.preventDefault()

    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.innerHTML = ""
      frame.removeAttribute("src")
    }
  }

  backdrop(event) {
    if (event.target === event.currentTarget) {
      this.close(event)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close(event)
    }
  }
}
